module.exports = __webpack_public_path__ + "static/media/catalyst-question-bg.1db36685.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/catalyst-question-bg.png
// module id = 1126
// module chunks = 0